module.exports = __webpack_public_path__ + "img/edit.5e9d7b44.svg";